import React from 'react';
import { useQuery } from '@apollo/client';
import { gql } from '@yi/core';

import { getSeriesItemUrl, getSeriesTitle, SeriesEpisodePageContext } from '~/src/common/lean-back';
import { usePageContext } from '~/src/components/PageContextProvider';

import { Link } from './elements';

export const SeriesLink: React.FC = () => {
  const { seriesId } = usePageContext<SeriesEpisodePageContext>();

  const { error, data, loading } = useQuery<
    gql.typesClient.Query_Series,
    gql.typesClient.Query_SeriesVariables
  >(gql.Query_Series, {
    variables: { id: seriesId },
    fetchPolicy: 'cache-and-network',
  });

  if (typeof error !== 'undefined' || loading || typeof data === 'undefined') {
    return null;
  }
  return <Link to={getSeriesItemUrl(data.Series)}>{getSeriesTitle(data.Series)}</Link>;
};
